import { Switch, Route } from "react-router-dom";
import WizardPage from "../Wizard";
import MasterRegistrationInfoPage from "./RegistrarionInfo/MasterRegistrationInfoPage";
import BachelorRegistrationInfoPage from "./RegistrarionInfo/BachelorRegistrationInfoPage";
import HtlRegistrationInfoPage from "./RegistrarionInfo/HlfRegistrationInfoPage";
import NoDiplomaRegistrationInfoPage from "./RegistrarionInfo/NoDiplomaRegistrationInfoPage";
import RegisterationMemberOptionsPage from "./RegistrationOptions/RegistrationMemberOptionsPage";
import MasterPage from "./Master/Master";
import BachelorPage from "./Bachelor/Bachelor";
import SingleMemberPage from "pages/Wizard/Forms/Single/SingleMemberPage";
import PrivateRoute from "PrivateRoute";
import GlobalContext from "contexts/GlobalContext";
import { useContext, useEffect, useState } from "react";
import StudentMemberPage from "../Forms/Student/StudentMemberPage";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import CorporateMemberPage from "../Forms/Corporates/CorporateMemberPage";
const WizardRoutes = () => {
  const globalContext = useContext(GlobalContext);
  const userId = globalContext.user?.siaId;
  const [wizardSession, setWizardSession] = useState({});
  useEffect(() => {
    if (userId) {
      pgAdapter.getWizardSession(userId, (data) => {
        setWizardSession(data);
      });
    }
  }, [userId]);
  return (
    <GlobalContext.Provider value={{ ...globalContext, wizardSession: wizardSession }}>
      <Switch>
        <Route exact path="/:languageKey/wizard" render={() => <WizardPage />} />
        <PrivateRoute exact path="/:languageKey/wizard/registration-info/master" render={() => <MasterRegistrationInfoPage />} />
        <PrivateRoute exact path="/:languageKey/wizard/registration-info/bachelor" render={() => <BachelorRegistrationInfoPage />} />
        <PrivateRoute exact path="/:languageKey/wizard/registration-info/htl" render={() => <HtlRegistrationInfoPage />} />
        <PrivateRoute exact path="/:languageKey/wizard/registration-info/no-diploma" render={() => <NoDiplomaRegistrationInfoPage />} />
        <PrivateRoute exact path="/:languageKey/wizard/member-options" render={() => <RegisterationMemberOptionsPage />} />
        <PrivateRoute exact path="/:languageKey/wizard/master" render={() => <MasterPage />} />
        <PrivateRoute exact path="/:languageKey/wizard/bachelor" render={() => <BachelorPage />} />
        <PrivateRoute exact path="/:languageKey/wizard/register/single" render={() => <SingleMemberPage />} />
        <PrivateRoute exact path="/:languageKey/wizard/register/student" render={() => <StudentMemberPage />} />
        <PrivateRoute exact path="/:languageKey/wizard/register/corporate" render={() => <CorporateMemberPage />} />
      </Switch>
    </GlobalContext.Provider>
  );
};

export default WizardRoutes;
